import Equities from "../../Functionality/Equities/Equities";
import Options from "../../Functionality/Options/Options";  
import Warrants from "../../Functionality/Warrants/Warrants";
import ConvertibleInstruments from "../../Functionality/ConvertibleInstruments/ConvertibleInstruments";

export const LeftNavLinks = {
    securities: [
      { label: "Equities", key: "equities", component: Equities },
      { label: "Options", key: "options", component: Options },
      { label: "Warrants", key: "warrants", component: Warrants },
      { label: "Convertible Instruments", key: "convertible-instruments", component: ConvertibleInstruments }
    ]
  };
  